import { render, staticRenderFns } from "./AddPendingMessage.vue?vue&type=template&id=5b41e98a&scoped=true&"
import script from "./AddPendingMessage.vue?vue&type=script&lang=js&"
export * from "./AddPendingMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b41e98a",
  null
  
)

export default component.exports